import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChevronTriangleUpSmall"><Path d="M14.5873 12.1848C14.8528 12.5115 14.6203 13.0001 14.1993 13.0001H9.80026C9.37924 13.0001 9.14671 12.5115 9.4122 12.1848L11.6117 9.47767C11.8118 9.2314 12.1877 9.2314 12.3878 9.47767L14.5873 12.1848Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChevronTriangleUpSmall;
